module.exports = __webpack_public_path__ + "img/rememberNo.5fc610fe.svg";